import { render, staticRenderFns } from "./BitrateInfoPopover.vue?vue&type=template&id=56336b49&"
import script from "./BitrateInfoPopover.vue?vue&type=script&lang=js&"
export * from "./BitrateInfoPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2141801166/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56336b49')) {
      api.createRecord('56336b49', component.options)
    } else {
      api.reload('56336b49', component.options)
    }
    module.hot.accept("./BitrateInfoPopover.vue?vue&type=template&id=56336b49&", function () {
      api.rerender('56336b49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Device/BitrateInfoPopover.vue"
export default component.exports